import styled from 'styled-components';
import { Tab, TabList } from "@fluentui/react-components";

export const StyledTabList = styled(TabList)`
    width: 100%;
`;

export const StyledTab = styled(Tab)`
    width: 50%;
    outline: none;
`;